import { AnchorHTMLAttributes, ReactNode } from "react";
import { motion, HTMLMotionProps } from "framer-motion";
import { trackDownloadClick, DownloadType, getDownloadUrl } from "@/utils/download";

interface DownloadMotionLinkProps extends HTMLMotionProps<"a"> {
  /** 下载类型，用于统计 */
  downloadType?: DownloadType;
  /** 子元素 */
  children: ReactNode;
  /** 是否在新窗口打开 */
  openInNewTab?: boolean;
}

/**
 * 带动画的下载链接组件
 * 基于 framer-motion 的 motion.a，自动处理 Facebook Pixel 统计
 */
export default function DownloadMotionLink({
  downloadType = "link",
  children,
  openInNewTab = false,
  onClick,
  ...props
}: DownloadMotionLinkProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // 触发下载点击统计
    trackDownloadClick(downloadType);

    // 调用原有的 onClick 处理函数
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <motion.a
      href={getDownloadUrl()}
      target={openInNewTab ? "_blank" : undefined}
      rel={openInNewTab ? "noopener noreferrer" : undefined}
      onClick={handleClick}
      {...props}
    >
      {children}
    </motion.a>
  );
}
